import react from 'react';
import Board from './components/board';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link
} from 'react-router-dom';
function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/chess-game/" element={
          <div className="menu_container container">
            <img src={require('./logo.jpg')} className="top_logo" alt="Chess empire logo" /><br />
            <button className="btn btn-dark menu_btn btn-disable">Computer</button><br />
            <Link to="/chess-game/friends" className="btn btn-dark menu_btn">Friends</Link><br />
            <button className="btn btn-dark menu_btn btn-disable">Learn</button>
          </div>
        }></Route>
        <Route exact path="/chess-game/friends" element={<Board/>}></Route>
      </Routes>
    </Router>
  );
}
export default App;